import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, DialogContent, DialogTitle, DialogActions, Dialog, Grid } from '@material-ui/core';

import TextField from '@material-ui/core/TextField';
import { useNotify } from '../../hooks/useNotify';
import { doSwaggerCall } from '../../hooks/useSwaggerClient';

function CreateNewIslandModal({ showModal, MODAL_TYPE }) {
    const [name, setName] = useState(null);
    const [vat, setVat] = useState(null);
    const { notifySuccess, notifyError } = useNotify();
    const history = useHistory();

    const createIsland = useCallback(() => {
        doSwaggerCall('islands', 'createIsland', {
            island: {
                name,
                vat: parseFloat(vat)
            }
        })
            .then(newIsland => {
                notifySuccess('New region created!');
                showModal(MODAL_TYPE.NONE);
                history.push(`/admin/regions/update/${newIsland.id}`);
            })
            .catch(err => {
                console.log(err);
                notifyError('Error during region creation!');
            });
    }, [name, vat, notifySuccess, notifyError, showModal, history]);

    return (
        <form>
            <Dialog
                aria-labelledby="client-modal"
                open
                onClose={() => showModal(MODAL_TYPE.NONE)}
                maxWidth="md"
            >
                <DialogTitle>Create new region</DialogTitle>
                <DialogContent>
                    <form
                        id="newisland-form"
                        onSubmit={ev => {
                            ev.preventDefault();
                            createIsland();
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Name"
                                    type="text"
                                    value={name}
                                    onChange={ev => setName(ev.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Tax Rate"
                                    type="text"
                                    value={vat}
                                    onChange={ev => setVat(ev.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={() => showModal(MODAL_TYPE.NONE)}>
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!name}
                        type="submit"
                        form="newisland-form"
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </form>
    );
}

export default CreateNewIslandModal;
